<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">Add Merchandise Color</div>
    </div>
    <div class="white-wrapper" style="zoom: 0.9">
      <form class="row">
        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="color_name"
                type="text"
                name="color_name"
                id="color_name"
              />
              <label>Color Name</label>
            </div>
          </div>
        </div>

        <div class="col-lg-1 col-xl-1 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material p-0">
              <input
                placeholder="."
                v-model="color_code"
                type="color"
                name="color_code"
                id="color_code"
                class="p-0 m-0"
              />
              <label>Color Code</label>
            </div>
          </div>
        </div>

        <div class="col-lg-4 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                placeholder="."
                v-model="color_description"
                type="text"
                name="color_description"
                id="color_description"
              />
              <label>Description</label>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(true)"
            class="btn-blue"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetForm()" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="merchandise-color"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      btenable: false,
      color_name: "",
      color_code: "",
      color_description: "",
      color_is_active: "Y",
      submitted: false,
    };
  },
  mounted() {},
  methods: {
    OnFinalSubmit: function (redirect) {
      this.submitted = true;
      if (!this.color_name) {
        return this.$toasted.show("Please Enter Color Name");
      } else if (!this.color_code) {
        return this.$toasted.show("Please Select Color");
      } else {
        let payload = {
          color_name: this.color_name,
          color_code: this.color_code,
          color_description: this.color_description,
          color_is_active: "Y",
        };
        MasterService.AddMerchandiseColor(payload)
          .then((response) => {
            this.btenable = false;
            const { data } = response;
            if (data && data.status) {
              this.resetForm();
              if (redirect) {
                this.$router.push({
                  path: "merchandise-color",
                });
              }
              this.submitted = false;
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          });
      }
    },
    resetForm: function () {
      this.color_name = "";
      this.color_code = "";
      this.color_description = "";
      this.color_is_active = "Y";
      this.btenable = false;
      this.submitted = false;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Pages/ExhibitorManagement/MechandiseComponents/AddMerchandiseColor.vue